import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const SocketActions = createActionGroup({
  events: {
    'Connect': emptyProps(),
    'Disconnect': emptyProps(),
    'Join Device Room': props<{ deviceId: string; }>(),
    'Leave Device Room': props<{ deviceId: string; }>(),
    'Reconnet': emptyProps(),
  },
  source: 'Sockets',
});
